<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0" v-if="stockSerial.length == 0">
				<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0" :responsive="{0:{items:1},600:{items:3},1000:{items:5}}" :margin="10" :autoplay="false" :nav="false" :loop="false" :dots="true" :autoplayTimeout=6000 :autoplayHoverPause="true">
					<div class="bg-white rounded-cus cus-box-shadow" v-for="(index) in 2" :key="index">
						<vcl :width='400' :height='155'>
							<rect x="310" y="32" rx="10" ry="10" width="60" height="60" />
							<rect x="25" y="30" rx="2" ry="2" width="250" height="25" />
							<rect x="25" y="70" rx="2" ry="2" width="170" height="25" />
						</vcl>
					</div>
				</carousel>
			</div>
			<div class="col-12 pl-0 pr-0" v-else-if="stockSerial == 'error'">
			</div>
			<div class="col-12 pl-0 pr-0" v-else>
				<div v-if="Object.values(stockSerial).length > 0">
					<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0" :responsive="{0:{items:1},600:{items:3},1000:{items:5}}" :margin="10" :autoplay="false" :nav="false" :loop="false" :dots="true" :autoplayTimeout=6000 :autoplayHoverPause="true">
						<div class="col-12 pl-0 bg-white rounded-cus cus-box-shadow cursor-pointer d-flex filter-history box-serial" v-for="(stock, index) in stockSerial" :key="index" @click="pilihSerial(stock.stock_serial_type)" :class="stock.stock_serial_type == serialType.value ? 'active' : '' ">
							<div class="col-9 pr-0 mt-auto mb-auto">
								<div class="col-12 pl-0 pr-0 font-size-9">{{stock.stock_serial_name}}</div>
								<div class="col-12 pl-0 pr-0 font-size-13 color-blue">{{stock.stock_pos}}</div>
							</div>
							<div class="col-3 pr-0 mt-auto mb-auto" v-if="false">
								<img class="img-fluid" :src="stock.product_image_filename">
							</div>
						</div>
					</carousel>
				</div>
			</div>
			<div class="col-12 col-md-12 pl-0 pr-0 mt-3">
				<div class="col-12 p-0 bg-white rounded-top-cus cus-box-shadow z-index-1">
					<div class="col-12 p-0 d-flex pt-3 pl-3 pl-md-4">
						<div class="col-12 p-0">
							<div class="row">
								<div class="col-6 col-md-6 font-size-sm-11">
									<p>Stok Serial</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 p-0 bg-white rounded-bot-cus cus-box-shadow">
					<div class="col-12 p-0 pt-3 pl-3 pl-md-4 pb-2 cursor-pointer filter-title" data-toggle="collapse" data-target="#filterRiwayatStok" @click="toggleFilter" :class="tfilter == true ? 'active' : ''">
						<div class="col-12 p-0 font-size-sm-10 font-size-10 d-flex">
							<span class="mr-2"><i class="fas fa-filter"></i></span>
							<div>Filter</div>
						</div>
					</div>
					<div id="filterRiwayatStok" class="collapse">
						<div class="col-12 pb-3 pl-3 pr-3 pl-md-4 pr-md-4 font-size-10">
							<div class="col-12 pl-0 pr-0 d-md-flex flex-wrap">
								<div class="col-12 col-md-8 col-lg-4 pl-0 pr-0 d-flex">
									<div class="col-3 pl-0 pt-1 font-size-sm-9">Waktu Beli</div>
									<div class="col-9 pl-0 pr-0 pr-md-3 d-flex">
										<div class="col-6 pl-0 pr-2">
											<datetime input-id="tanggalAwal" :max-datetime="maxDate" :min-datetime="new Date('2000-01-01').toISOString()" v-model="tanggalAwal" id="awalBeli" class="theme-purple h-100" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9 font-size-sm-8" placeholder="Dari Tanggal"></datetime>
										</div>
										<div class="col-6 pl-0 pr-0">
											<datetime input-id="tanggalAkhir" :max-datetime="maxDate" :min-datetime="new Date('2000-01-01').toISOString()" v-model="tanggalAkhir" id="awalBeli" class="theme-purple" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9 font-size-sm-8" placeholder="Sampai Tanggal"></datetime>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-8 col-lg-4 pl-0 pr-0 pt-2 pt-lg-0 d-flex">
									<div class="col-3 pl-0 pt-1 font-size-sm-9">Waktu Jual</div>
									<div class="col-9 pl-0 pr-0 pr-md-3 d-flex">
										<div class="col-6 pl-0 pr-2">
											<datetime input-id="tanggalAwalTerjual" :max-datetime="maxDateTerjual" :min-datetime="new Date('2000-01-01').toISOString()" v-model="tanggalAwalTerjual" id="AwalTerjual" class="theme-purple h-100" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9 font-size-sm-8" placeholder="Dari Tanggal"></datetime>
										</div>
										<div class="col-6 pl-0 pr-0">
											<datetime input-id="tanggalAkhirTerjual" :max-datetime="maxDateTerjual" :min-datetime="new Date('2000-01-01').toISOString()" v-model="tanggalAkhirTerjual" id="AkhirTerjual" class="theme-purple" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9 font-size-sm-8" placeholder="Sampai Tanggal"></datetime>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-8 col-lg-4 pl-0 pr-0 pt-2 pt-lg-0 d-flex">
									<div class="col-3 pl-0 pt-1 font-size-sm-9">Kadaluarsa</div>
									<div class="col-9 pl-0 pr-0 pr-md-3 d-flex">
										<div class="col-6 pl-0 pr-2">
											<datetime input-id="tanggalAwalKadaluarsa" v-model="tanggalAwalKadaluarsa" id="AwalKadaluarsa" class="theme-purple h-100" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9 font-size-sm-8" placeholder="Dari Tanggal"></datetime>
										</div>
										<div class="col-6 pl-0 pr-0">
											<datetime input-id="tanggalAkhirKadaluarsa" v-model="tanggalAkhirKadaluarsa" id="AkhirKadaluarsa" class="theme-purple" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9 font-size-sm-8" placeholder="Sampai Tanggal"></datetime>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-md-2 pt-lg-3 d-flex flex-wrap">
								<div class="col-12 col-md-4 pl-0 pr-0 pt-2 pt-md-0 d-flex">
									<div class="col-3 pl-0 pt-1 font-size-sm-9">Serial</div>
									<div class="col-9 pl-0 pr-0 pr-md-3 d-flex">
										<div class="col-12 pl-0 pr-0">
											<input v-model="noSerial.value" class="form-control form-control-sm box-blue rounded-cus font-size-9 font-size-sm-8" type="text" placeholder="Kode Serial">
										</div>
									</div>
								</div>
								<div class="col-12 col-md-4 pl-0 pr-0 pt-2 pt-md-0 d-flex">
									<div class="col-3 pl-0 pt-1 font-size-sm-9">Status</div>
									<div class="col-9 pr-0 pr-md-3 pl-0 d-flex">
										<div class="col-12 pl-0 pr-0">
											<v-select v-model="pilihanSerial" label="text" class="font-size-9 font-size-sm-8" :options="status" placeholder="Semua">
											</v-select>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-4 pl-0 pr-0 pl-md-3 pr-md-3 pt-2 pt-md-0 d-flex">
									<div class="col-12 pl-0 pr-0 d-flex">
										<div class="col-6 pl-0 pr-2">
											<button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus">
												<div class="font-size-9" @click="reset">Reset</div>
											</button>
										</div>
										<div class="col-6 pl-2 pr-0">
											<button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus">
												<div class="font-size-9" @click="cari">Cari</div>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 pr-0">
				<div class="row" v-show="listStockResults.length == 0 ">
					<div class="col-12 col-md-6 col-lg-3 col-stock-serial pl-0 pt-3" v-for="(index) in 8" :key="index">
						<div class="col-12 pt-3 pb-3 bg-white rounded-cus cus-box-shadow">
							<vcl :width='300' :height='140' class="background-white rounded cus-box-shadow ">
								<rect x="230" y="0" rx="20" ry="5" width="170" height="20" />
								<rect x="20" y="20" rx="2" ry="2" width="95" height="15" />
								<rect x="20" y="42" rx="2" ry="2" width="80" height="15" />
								<rect x="20" y="70" rx="2" ry="2" width="80" height="12" />
								<rect x="120" y="70" rx="2" ry="2" width="130" height="12" />
								<rect x="20" y="90" rx="2" ry="2" width="60" height="12" />
								<rect x="120" y="90" rx="2" ry="2" width="130" height="12" />
								<rect x="20" y="110" rx="2" ry="2" width="85" height="12" />
								<rect x="120" y="110" rx="2" ry="2" width="130" height="12" />
							</vcl>
						</div>
					</div>
				</div>
				<div class="row" v-if="listStockResults == 'error'">
					<div class="col-12 pl-0 pt-3">
						<div class="col-12 pt-3 pb-3 bg-white rounded-cus cus-box-shadow">
							<div class="col-12 text-center">
								<div class="col-6 col-md-3 ml-auto mr-auto">
									<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
								</div>
								<div class="font-size-11 pt-1">Data tidak tersedia!</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-else>
					<div class="col-12 col-md-6 col-lg-3 col-stock-serial pl-0 pt-3" v-for="(value, index) in listStockResults" :key="index">
						<div class="col-12 pt-3 pb-3 bg-white rounded-cus cus-box-shadow" v-if="value.status_name == 'Terjual'">
							<div class="badge-serial bg-purple">Terjual</div>
							<div class="font-size-10">{{value.stock_serial_name}}</div>
							<div class="font-size-12 pt-1 color-purple">{{value.stock_serial_value}}</div>
							<div class="col-12 pl-0 pr-0 pt-2 d-flex">
								<div class="col-4 pl-0 font-size-9">Pembelian</div>
								<div class="col-8 pr-0 font-size-9">{{value.stock_serial_buy_datetime | tanggal}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-1 d-flex">
								<div class="col-4 pl-0 font-size-9">Terjual</div>
								<div class="col-8 pr-0 font-size-9">{{value.stock_serial_sell_datetime | tanggal}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-1 d-flex color-gray-2">
								<div class="col-4 pl-0 font-size-9">Kadaluarsa</div>
								<div class="col-8 pr-0 font-size-9">{{value.stock_serial_expired_datetime | tanggal}}</div>
							</div>
						</div>
						<div class="col-12 pt-3 pb-3 bg-white rounded-cus cus-box-shadow expired" v-else-if="value.status_name == 'Kedaluwarsa'">
							<div class="badge-serial bg-gray-2">Kadaluarsa</div>
							<div class="font-size-10">{{value.stock_serial_name}}</div>
							<div class="font-size-12 pt-1 color-purple">{{value.stock_serial_value}}</div>
							<div class="col-12 pl-0 pr-0 pt-2 d-flex">
								<div class="col-4 pl-0 font-size-9">Pembelian</div>
								<div class="col-8 pr-0 font-size-9">{{value.stock_serial_buy_datetime}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-1 d-flex">
								<div class="col-4 pl-0 font-size-9">Terjual</div>
								<div class="col-8 pr-0 font-size-9">{{value.stock_serial_sell_datetime | tanggal}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-1 d-flex color-gray-2">
								<div class="col-4 pl-0 font-size-9">Kadaluarsa</div>
								<div class="col-8 pr-0 font-size-9">{{value.stock_serial_expired_datetime | tanggal}}</div>
							</div>
						</div>
						<div class="col-12 pt-3 pb-3 bg-white rounded-cus cus-box-shadow" v-else>
							<div class="badge-serial bg-green">Tersedia</div>
							<div class="font-size-10">{{value.stock_serial_name}}</div>
							<div class="font-size-12 pt-1 color-purple">{{value.stock_serial_value}}</div>
							<div class="col-12 pl-0 pr-0 pt-2 d-flex" >
								<div class="col-4 pl-0 font-size-9">Pembelian</div>
								<div class="col-8 pr-0 font-size-9">{{value.stock_serial_buy_datetime | tanggal}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-1 d-flex">
								<div class="col-4 pl-0 font-size-9">Terjual</div>
								<div class="col-8 pr-0 font-size-9">-</div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-1 d-flex color-gray-2">
								<div class="col-4 pl-0 font-size-9">Kadaluarsa</div>
								<div class="col-8 pr-0 font-size-9">{{value.stock_serial_expired_datetime | tanggal}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<i-pagination :limit = 'limit' @changeLimit="changeLimit($event)" :pagination = 'paginationSerial' @gotoPage="gotoPage($event)"  @refresh="refresh($event)"></i-pagination>
		</div>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import IPagination from '@/components/IPagination.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	components: {
		carousel, IPagination
	},
	name: 'StockProduct',
	data() {
		return {
			currentDate : new Date().toLocaleString(),
			pilihanSerial : '',
			tanggalAwal:'',
			tanggalAkhir:'',
			tanggalAwalTerjual:'',
			tanggalAkhirTerjual:'',
			tanggalAwalKadaluarsa:'',
			tanggalAkhirKadaluarsa:'',
			serialType:{
				value:'',
				comparison:'=',
				type:'string',
				field:'stock_serial_type',
			},
      serialUsedFor:{
				value:'pos',
				comparison:'=',
				type:'string',
				field:'stock_serial_used_for',
			},
			tanggalPembelian:{
				value:'',
				comparison:'bet',
				type:'date',
				field:'stock_serial_buy_datetime',
			},
			tanggalKadaluarsa:{
				value:'',
				comparison:'bet',
				type:'date',
				field:'stock_serial_expired_datetime',
			},
			tanggalTerjual:{
				value:'',
				comparison:'bet',
				type:'date',
				field:'stock_serial_sell_datetime',
			},
			noSerial: {
				value:'',
				comparison:'LIKE',
				type:'string',
				field:'stock_serial_value'
			},
			statusSerialExpired: {
				value: '',
				comparison:'',
				type:'date',
				field: 'stock_serial_expired_datetime',
			},
			statusSerial: {
				value: '',
				comparison:'=',
				type:'string',
				field: 'stock_serial_status',
			},
			params:[],
			tfilter: false,
			page: 1,
			limit : 8,
			status: [{
				text: "Tersedia",
				value: 0
			}, {
				text: "Kadaluarsa",
				value: 1
			}, {
				text: "Terjual",
				value: 2
			}],
		}
	},
	methods: {
		...mapActions('inventoryList', ['getStock', 'getDataStockByDate', 'getDetailStock', 'getListSerial', 'getDataStockSummarySerial']),

		gotoPage(val) {
			this.page  = val
			this.getListSerial(this.queryString({limit:this.limit, page: this.page, params:[this.serialType, this.serialUsedFor, ...this.params]}))
		},
		refresh(val) {
			this.page  = val
			this.getListSerial(this.queryString({limit:this.limit, page: this.page, params:[this.serialType, this.serialUsedFor, ...this.params]}))
		},
		changeLimit(val) {
			this.page = 1
			this.limit  = val
			this.getListSerial(this.queryString({limit:this.limit, page: this.page, params:[this.serialType, this.serialUsedFor, ...this.params]}))
		},
		toggleFilter() {
			if ( !this.tfilter ) {
				this.tfilter = true;
			} else {
				this.tfilter = false;
			}
		},
		reset() {
			this.pilihanSerial = ''
			this.tanggalAwal = ''
			this.tanggalAkhir = ''
			this.tanggalAwalTerjual = ''
			this.tanggalAkhirTerjual = ''
			this.tanggalAwalKadaluarsa = ''
			this.tanggalAkhirKadaluarsa = ''
			this.tanggalPembelian.value = ''
			this.tanggalTerjual.value = ''
			this.statusSerial.value = ''
			this.noSerial.value = ''
			this.statusSerialExpired.comparison = ''
			this.statusSerialExpired.value = ''
			this.page  = 1
			this.limit = 8
			this.getListSerial(this.queryString({limit:this.limit, page: this.page, params:[this.serialType, this.serialUsedFor]}))
		},
		cari() {
			this.params = []
			this.page = 1
			this.limit = 8
			if(!this.tanggalAkhir) {
				this.tanggalAkhir = this.tanggalAwal
			}
			if(this.tanggalAwal && this.tanggalAkhir) {
				this.tanggalPembelian.value = moment(this.tanggalAwal).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhir).format('YYYY-MM-DD')
				this.params.push(this.tanggalPembelian)
			}

			if(!this.tanggalAkhirTerjual) {
				this.tanggalAkhirTerjual = this.tanggalAwalTerjual
			}
			if(this.tanggalAwalTerjual && this.tanggalAkhirTerjual) {
				this.tanggalTerjual.value = moment(this.tanggalAwalTerjual).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhirTerjual).format('YYYY-MM-DD')
				this.params.push(this.tanggalTerjual)
			}

			if(!this.tanggalAkhirKadaluarsa) {
				this.tanggalAkhirKadaluarsa = this.tanggalAwalKadaluarsa
			}
			if(this.tanggalAwalKadaluarsa && this.tanggalAkhirKadaluarsa) {
				this.tanggalKadaluarsa.value = moment(this.tanggalAwalKadaluarsa).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhirKadaluarsa)
				this.params.push(this.tanggalKadaluarsa)
			}

			if(this.noSerial.value) {
				this.params.push(this.noSerial)
			}
			if(this.pilihanSerial) {

				if(this.pilihanSerial.value == 0) {
					this.statusSerial.value = '0'
					this.statusSerialExpired.comparison = '>'
					this.statusSerialExpired.value = moment(this.currentDate).format('YYYY-MM-DD')
					this.params.push(this.statusSerial)
					this.params.push(this.statusSerialExpired)
				} else if(this.pilihanSerial.value == 1) {
					this.statusSerial.value = '0'
					this.statusSerialExpired.comparison = '<'
					this.statusSerialExpired.value = moment(this.currentDate).format('YYYY-MM-DD')
					this.params.push(this.statusSerial)
					this.params.push(this.statusSerialExpired)
				} else if(this.pilihanSerial.value == 2) {
					this.statusSerial.value = '1'
					this.params.push(this.statusSerial)
				} else {
					this.statusSerial.value = ''
				}
			}
			this.getListSerial(this.queryString({limit:this.limit, page: this.page, params:[this.serialType, this.serialUsedFor, ...this.params]}))
		},
		pilihSerial (code) {
			this.serialType.value = code
			this.page = 1
			this.params = []
			this.limit = 8
			this.getListSerial(this.queryString({limit:this.limit, page: this.page, params:[this.serialType, this.serialUsedFor]}))
		},
	},
	computed: {
		...mapState('inventoryList', ['dataStock', 'stockSerial', 'paginationSerial', 'listStockResults']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),

		maxDate(){
			var date = new Date().toISOString()
			if (this.tanggalAkhir) {
				date = new Date(this.tanggalAkhir).toISOString()
			}
			return date
		},
		maxDateTerjual(){
			var date = new Date().toISOString()
			if (this.tanggalAkhirTerjual) {
				date = new Date(this.tanggalAkhirTerjual).toISOString()
			}
			return date
		}
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Stok Serial');
		this.getDataStockSummarySerial().then(() => {
			this.serialType.value = this.stockSerial[0].stock_serial_type
			this.getListSerial(this.queryString({limit:this.limit, page: this.page, params:[this.serialType, this.serialUsedFor]}))
		})
	}
};
</script>
